<template>
  <div class="bag-inner1" style="position: relative;">
    <div class="custom-shape-divider-top-1632817622">
      <svg
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1200 120"
        preserveAspectRatio="none"
      >
        <path
          d="M1200 120L0 16.48 0 0 1200 0 1200 120z"
          class="shape-fill"
        ></path>
      </svg>
    </div>
    <div style="padding-bottom: 20px; z-index:11;">
      <img src="../../img/baseImg/logo.png" style="height: 70px;" />
      <el-form ref="form" :model="form" :rules="rules" label-width="0px" class="login-form">
        <el-form-item prop="userName">
          <el-input
            class="sign"
            v-model="form.userName"
            placeholder="请输入用户名"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            class="sign"
            type="password"
            v-model="form.password"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            class="submit-button"
            :loading="signLoading"
            type="primary"
            @click="submitForm"
            >{{ signLoading ? "登录中......" : "登录" }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="positionlogin"></div>
    <!-- <div class="c positionbase" style="left:12%;top:3%;"><span data-z data-z-event="pointer" data-z-eventRotation="20deg" >A<span style="font-size:5vw;">n</span></span></div>
    <div class="c positionbase" style="right:12%;bottom:15%;transform: rotate(30deg);"><span data-z data-z-event="pointer" data-z-eventRotation="20deg">J<span style="font-size:6vw;">i</span></span></div> -->
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      form: {
        userName: null,
        password: null
      },
      signLoading: false,
      // 表单校验
      rules: {
        userName: [
          { required: true, message: "用户名不能为空", trigger: "blur" }
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" }
        ],
      }
    };
  },
  methods: {
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.signLoading = true;
          this.post("/user/login", {
            userName: this.form.userName,
            password: this.form.password
          }).then(res => {
            if (res.data.code == 200) {
              var str = res.data.data.functions;
              var jurisdiction = JSON.stringify(str);
              localStorage.setItem("token", res.data.data.token);
              localStorage.setItem("useId", res.data.data.id); //用户id
              localStorage.setItem("jurisdiction", jurisdiction); //权限
              localStorage.setItem("data", JSON.stringify(res.data.data)); //data
              this.$notify({
                title: "成功",
                message: "登录成功",
                type: "success"
              });
              this.$router.push({ path: `/guide` });
            }
          }).catch(err => {
            this.signLoading = false
          })
        }
      });
    },
  },
  mounted() {
  },
  // 销毁监听事件
  destroyed() {
  },
  created: function() {}
};
</script>

<style scoped>
.sign /deep/ .el-input__inner {
  height: 45px;
  line-height: 45px;
  background-color: rgb(255 255 255 / 0%);
  border: 2px solid #737884b3;
}
.sign /deep/ .el-form-item__label {
  color: #fff;
}

.sign /deep/ .el-button--primary {
  color: white;
  background-color: #00445e;
  border-color: #00445e;
}
.bag-inner1 {
  width: 100vw;
  height: 100vh;
  background-color: #2e2e2e;
  background-repeat: no-repeat;
  background-image: url(~@/img/baseImg/logobj.png);
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.positionlogin {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 20vw;
  height: 25vh;
  background-image: url(~@/img/baseImg/login.gif);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.custom-shape-divider-top-1632817622 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  line-height: 0;
}

.custom-shape-divider-top-1632817622 svg {
  position: relative;
  display: block;
  width: calc(100% + 1.3px);
  height: 300px;
}

.custom-shape-divider-top-1632817622 .shape-fill {
  fill: #6a719d;
}
.c {
  font-size: 10vw;
  color: #2e2e2e;
  font-weight: 900;
  /* 给文字添加白边框 */
  -webkit-text-stroke: 2px #fff;
  line-height: 200px;
  transform: rotate(-10deg);
}
.positionbase {
  position: absolute;
  z-index: 10;
}
.styleInput {
  border: 1px solid #fff;
  caret-color: #fff;
  color: #fff;
}
.sign >>> input {
  color: #fff;
}
.z-text {
  transform: rotateY(-15deg);
  transition: transform 1s;
}

.z-layer:not(:first-child) {
  color: #bf5433;
}

.login-form {
  margin-top: 55px;
}

.submit-button {
  width: 380px;height: 42px;font-size: 19px;font-weight: bolder; margin-top:30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/sign/index.vue